import Wrapper from "../../Layout/Wrapper/wrapper";
import "./styles.scss";
import { FooterProps } from "./types";
import { ReactSVG } from "react-svg";

const FooterHome = ({ data }: FooterProps) => {
  return (
    <footer>
      <div className="FooterHome">
        <Wrapper>
          <div className="FooterHome__wrapper">
            <ReactSVG
              className="FooterHome__logo"
              src={data.logoPath}
            />
            <ul className="FooterHome__links">
              <li className="FooterHome__link">
                <a href="/about-us">About Us</a>
              </li>
              <li className="FooterHome__link">
                <a href="/faq">FAQ</a>
              </li>
              <li className="FooterHome__link">
                <a href="/terms-and-conditions">Terms and Conditions</a>
              </li>
              <li className="FooterHome__link">
                <a href="/terms-of-use">Terms of Use</a>
              </li>
              <li className="FooterHome__link">
                <a href="/cookie-policy">Cookie Policy</a>
              </li>
              <li className="FooterHome__link">
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li className="FooterHome__link">
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>
        </Wrapper>
      </div>
      <div className="FooterHome__copyright">
        <Wrapper>
          <span>
            © Copyright 2024 <span></span>. All rights reserved.
          </span>
        </Wrapper>
      </div>
    </footer>
  );
};

export default FooterHome;
